import React from "react";
import LegalPageLayout from "@/components/site/LegalPageLayout";

const Section = ({ n, title, children }) => (
  <section className="mt-8">
    <h2 className="font-heading text-xl font-bold text-slate-950 mb-3">
      {n}. {title}
    </h2>
    <div className="space-y-3 text-sm sm:text-base">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <LegalPageLayout
      testId="privacy-page"
      title="Privacy Policy"
      subtitle="How Rana Associates collects, uses, discloses and protects personal, KYC, geolocation and property data on behalf of the banks, NBFCs and field executives who use the Platform."
      lastUpdated="22 February 2026"
    >
      <Section n="1" title="Information We Collect">
        <p><b>Account information</b> — name, email, phone, role, employer/bank name.</p>
        <p><b>KYC information</b> (Field Executives) — Aadhaar and PAN numbers, home address, working pincode.</p>
        <p><b>Property inspection data</b> — geo-tagged photos, plot dimensions, boundary details, bylaw notes, valuation amounts.</p>
        <p><b>Device &amp; usage data</b> — IP address, device type, browser, session cookies, page-view analytics.</p>
      </Section>

      <Section n="2" title="How We Use Your Data">
        <p>To operate the property valuation workflow, route leads by pincode to the appropriate manager and field executive, generate reports for banks, compute executive payouts, and provide customer support.</p>
        <p>To send transactional emails (password reset, lead assignment, report status updates) via our email service partner.</p>
        <p>To detect fraud, enforce our Terms and comply with legal or regulatory requests.</p>
      </Section>

      <Section n="3" title="Data Sharing">
        <p>We share property inspection data only with the requesting bank and its authorised staff. We share Field Executive KYC only with the executive's approving Manager and with the bank on need-to-know basis for high-value reports.</p>
        <p>We do <b>not</b> sell your data to advertisers or third parties.</p>
        <p>We may share data with law-enforcement or regulatory authorities upon a valid legal request.</p>
      </Section>

      <Section n="4" title="Data Retention">
        <p>Account and report data is retained for the duration of the bank/executive relationship plus 7 years thereafter (RBI record-keeping norm). KYC data is retained per applicable KYC/AML law. On written request, we will delete non-mandatory data within 30 days.</p>
      </Section>

      <Section n="5" title="Security">
        <p>We hash passwords with bcrypt, encrypt data in transit (TLS 1.2+), and use scoped role-based access control (RBAC) with tenant isolation. Photo and document storage uses signed URLs with short expiry.</p>
        <p>Login endpoints are protected by rate-limiting (5 failed attempts triggers a 15-minute lockout). Password reset links are one-time-use and expire in 30 minutes.</p>
      </Section>

      <Section n="6" title="Your Rights">
        <p>You have the right to access, correct or delete your personal data, and to object to specific processing activities. To exercise these rights, email <a href="mailto:privacy@ranaassociate.com" className="text-amber-700 underline">privacy@ranaassociate.com</a>.</p>
      </Section>

      <Section n="7" title="Cookies">
        <p>We use only functional cookies (authentication session, language preference). We do not use third-party advertising cookies.</p>
      </Section>

      <Section n="8" title="Children's Privacy">
        <p>The Platform is intended for adult professionals only and is not directed to children under 18.</p>
      </Section>

      <Section n="9" title="Changes to this Policy">
        <p>Material changes will be communicated at least 15 days in advance via email and a banner on the Platform. Continued use after the effective date constitutes acceptance.</p>
      </Section>

      <Section n="10" title="Grievance Officer">
        <p>In accordance with Section 5(9) of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011:</p>
        <p>Name: Grievance Officer, Rana Associates<br />Email: <a href="mailto:grievance@ranaassociate.com" className="text-amber-700 underline">grievance@ranaassociate.com</a><br />Jurisdiction: Jaipur, Rajasthan, India</p>
      </Section>
    </LegalPageLayout>
  );
}
